import React, { useContext, useEffect, useState } from 'react';
import styles from './PackagesModal.module.css';
import Modal from '../Modal/Modal';
import { getAppEnv } from '../../../config/env';
import { Context } from '../../AppContext';
// import { logRttEventLogger } from '../../logRttRequestBuilder';

interface PackageInfo {
  title: string;
  sub_title: string;
  package_name: string;
  package_description: Array<{
    icon: string;
    text: string;
  }>;
  city_list: Array<{
    image_url: string;
    name: string;
  }>;
  view_cta_title: string;
  view_cta_sub_title: string;
  close_cta: string;
  redirection_url: string;
}

interface PackagesModalProps {
  packageData: PackageInfo;
  onClose: () => void;
  show: boolean;
  pageUrl: string;
}

const PackagesModal: React.FC<PackagesModalProps> = ({
  packageData,
  onClose,
  pageUrl,
  show
}) => {
  const { trackTemplateEvent, omniUrlArgs } = useContext(Context);
  const env = getAppEnv();
  const { PUBLIC_URL } = env.raw;

  const descriptionLength = packageData.package_description.length;
  const [currentDescIndex, setCurrentDescIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDescIndex(prev => (prev + 1) % descriptionLength);
    }, 1500);

    return () => clearInterval(timer);
  }, [descriptionLength]);

  const handleViewCta = () => {
    // window.open(packageData.redirection_url, '_blank');
    if (packageData.redirection_url) {
      window.location.href = `${packageData.redirection_url}&${omniUrlArgs}`;
    }
    //  logRttEventLogger({
    //     omniUrlArgs,
    //     eventName: 'Cab_SEO_Packages_Modal_Clicked',
    //     pageUrl,
    //   })
    trackTemplateEvent(`Cab_SEO_Packages_Modal_Clicked`);
  };
  return (
    <Modal
      show={show}
      onClose={onClose}
      customParentClass={styles.modalContainer}
    >
      <div className={styles.packagesModal}>
        <div className={styles.header}>
          <h2 className={styles.headerTitle}>{packageData.title}</h2>
        </div>

        <div className={styles.packageDetails}>
          <p className={styles.subtitle}>{packageData.sub_title}</p>
          <h3 className={styles.title}>{packageData.package_name}</h3>
          <div className={styles.packageDescriptionContainer}>
            <div className={styles.descriptionWrapper} key={currentDescIndex}>
              <img
                src={`${PUBLIC_URL}/static/public/sealTick.png`}
                alt=""
                className="description-icon"
              />
              <p className={styles.packageDescription}>
                {packageData.package_description[currentDescIndex].text}
              </p>
            </div>
          </div>
        </div>

        <div className={styles.cityList}>
          {packageData.city_list.map((city, index) => (
            <div key={`city-${index}`} className={styles.cityItem}>
              <img
                src={`${PUBLIC_URL}/static/public/${city.image_url}`}
                alt={city.name}
                className={styles.cityImage}
              />
              <span className={styles.cityName}>{city.name}</span>
            </div>
          ))}
        </div>

        <div className={styles.footer}>
          <button className={styles.viewCta} onClick={handleViewCta}>
            <div className={styles.ctaContent}>
              <span className={styles.ctaTitle}>
                {packageData.view_cta_title}
              </span>
              <span className={styles.ctaSubtitle}>
                {packageData.view_cta_sub_title}
              </span>
            </div>
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PackagesModal;
